import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import apiHelperService from '@/services'
import client_lookup from '@/assets/json/clientLookups.json'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    immigrationDepartmentId = '',
    administrativeRegionId = '',
    withException = '',
    sponsorTypeId = '',
    applicationToken = '',
    sponsoredUN = '',
    fileNumber = ''
  } = router.currentRoute.value.query
  const {
    requestCancelTransaction: { residencyCancel },
    transactionReason: { uponSponsorRequest }
  } = client_lookup
  formStore.extraMap = {
    ...formStore.extraMap,
    serviceTransactionId,
    administrativeRegionId,
    withException: withException == 'true'
  }
  if (immigrationDepartmentId) {
    formStore.draft.request.sponsorDepartmentId = immigrationDepartmentId
  }
  if (sponsorTypeId) {
    formStore.draft.request.sponsorTypeId = sponsorTypeId
  }
  if (applicationToken) {
    formStore.draft.request.applicationToken = applicationToken
  }
  if (serviceTransactionId == residencyCancel) {
    formStore.draft.request.transactionReasonId = uponSponsorRequest
  }
  if ([122, 406].includes(serviceTransactionId)) {
    set122DefaultVal({ fileNumber, sponsoredUN, serviceTransactionId })
  }
}

const initInfo = async () => {
  const formStore = useFormStore()
  const { serviceTransactionId } = formStore.extraMap
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    if ([70, 71, 993].includes(serviceTransactionId)) {
      set70DefaultVal(res)
    }

    if ([443].includes(serviceTransactionId)) {
      set443DefaultVal()
    }
    formStore.draft.request = {
      ...formStore.draft.request,
      individualInfo: res,
      sponsorGenderId: res.genderId
    }
    formStore.extraMap.individualInfo = res
  }
}

const set443DefaultVal = async () => {
  const formStore = useFormStore()
  const {
    relationships: { samePerson }
  } = client_lookup
  const res = await apiHelperService.get(`/api/individual/user/immigrationFile/details`)
  const {
    unifiedNumber = '',
    departmentCode = '',
    year = '',
    serviceCode = '',
    sequence = '',
    identityNumber = '',
    fullNameEnglish = '',
    fullNameArabic = '',
    lookupCurrentNationalityId = '',
    lookupGenderId = '',
    lookupBirthCountryId = '',
    dateOfBirth = '',
    lookupMaritalStatusId = '',
    lookupPassportTypeId = '',
    passportNumber = '',
    passportIssueDate = '',
    passportExpiryDate = '',
    lookupPassportCountryId = '',
    fileNumber = '',
    sponsorImmigrationDepartmentId = '',
    sponsorNameEnglish = 'sponsorNameEnglish',
    sponsorNameArabic = 'سبينسورانجوليشون',
    sponsorNumber = '',
    sponsorTypeId = ''
  } = res
  let obj = {
    personUnifiedNumber: unifiedNumber,
    resiDepartmentCode: departmentCode,
    resiYear: year,
    resiServiceCode: serviceCode,
    resiSequenceNumber: sequence,
    identityNumber: identityNumber,
    englishName: fullNameEnglish,
    arabicName: fullNameArabic,
    currentNationalityId: lookupCurrentNationalityId,
    genderId: lookupGenderId,
    countryOfBirthId: lookupBirthCountryId,
    dateOfBirth,
    maritalStatusId: lookupMaritalStatusId,
    passportTypeId: lookupPassportTypeId,
    passportNumber,
    passportIssueDate,
    passportExpiryDate,
    passportCountryId: lookupPassportCountryId,
    sponsorName: sponsorNameArabic,
    sponsorEnglishName: sponsorNameEnglish || 'sponsorNameEnglish',
    sponsorArabicName: sponsorNameArabic || 'سبنسوراشومانيكارا',
    sponsorDepartmentId: sponsorImmigrationDepartmentId,
    sponsorNumber,
    sponsorTypeId,
    fileNumber,
    sponsorRelationshipId: samePerson
  }

  Object.assign(formStore.draft.request, obj)
}

const set70DefaultVal = (res) => {
  const formStore = useFormStore()
  const { educationLevelId = '', countryOfBirthId = '', martialStatusId = '' } = res
  formStore.draft.request = {
    ...formStore.draft.request,
    maritalStatusId: martialStatusId,
    educationLevelId,
    countryOfBirthId
  }
}

const set122DefaultVal = async ({ serviceTransactionId, fileNumber, sponsoredUN }) => {
  const formStore = useFormStore()
  let params = {
    unifiedNumber: sponsoredUN,
    sponsoredFileNumber: fileNumber,
    serviceTransactionId
  }
  const res = await apiHelperService.post(
    `/api/udb/personImmigrationFile/prepare?serviceTransId=${serviceTransactionId}`,
    {
      ...params
    }
  )
  if (res) {
    formStore.draft.request = {
      ...formStore.draft.request,
      ...(res?.data?.residencyRequest || {}),
      isParentInsideUae: res.isParentInsideUae || 1,
      notApplicableLatestWorkPlaceHomeland: 0
    }
  }
}

export default async function () {
  try {
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('useResidencyPreload error: ', error)
  }
}
